import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { FeatureConfig, RouteKey } from "@/utils/feature-flag/environment";

interface FeatureState {
  config: FeatureConfig;
}

const initialState: FeatureState = {
  config: "*",
};

const featureFlagSlice = createSlice({
  name: "features-flags",
  initialState,
  reducers: {
    setFeatureConfig: (state, action: PayloadAction<FeatureConfig>) => {
      state.config = action.payload;
    },

    toggleRoute: (
      state,
      action: PayloadAction<{ route: RouteKey; enabled: boolean }>,
    ) => {
      if (state.config === "*") {
        state.config = {};
      }
      if (typeof state.config === "object") {
        state.config[action.payload.route] = action.payload.enabled;
      }
    },
  },
});

export const { setFeatureConfig, toggleRoute } = featureFlagSlice.actions;
export default featureFlagSlice.reducer;
